import { css } from '@emotion/css';

export const stepContainer = css`
  max-width: 1000px;
  margin: 0 auto;
  padding: 16px;
  position: relative;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

export const stepItem = css`
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  opacity: 0;
  transform: translateY(20px);
  transition:
    opacity 0.6s ease-out,
    transform 0.6s ease-out;

  &.animate {
    opacity: 1;
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    margin-bottom: 16px;
    align-items: center;
  }

  &:last-child {
    margin-bottom: 0;

    .step-line {
      display: none;
    }
  }
`;

export const stepNumber = css`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
  margin-right: 16px;

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 14px;
    margin-right: 12px;
    margin-top: 0;
  }
`;

export const stepNumberCompleted = css`
  background-color: #5e57c0;
  color: #ffffff;
  border: none;
`;

export const stepNumberActive = css`
  background-color: #ee8865;
  color: #ffffff;
  border: none;
`;

export const stepNumberUpcoming = css`
  background-color: #f5f5f5;
  color: #8c8c8c;
  border: 1px solid #d9d9d9;
`;

export const stepLine = css`
  position: absolute;
  left: 19px;
  top: 40px;
  width: 1px;
  height: calc(100% + 24px);
  background-color: #e8e8e8;
  z-index: 1;

  @media (max-width: 768px) {
    left: 15px;
    top: 32px;
    height: calc(100% + 16px);
  }
`;

export const cardContainer = css`
  flex: 1;
  width: 100%;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 80px;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;
    min-height: 60px;
    border-radius: 12px;
  }
`;

export const cardContainerCompleted = css`
  ${cardContainer};
  background-color: #ffffff;
  border: 1px solid #5e57c0;
`;

export const cardContainerActive = css`
  ${cardContainer};
  background-color: #fff7f0;
  border: 1px solid #ee8865;
  box-shadow: rgba(184, 92, 68, 0.267) 0px 0px 6.63922px 0px, rgba(184, 92, 68, 0.133) 0px 0px 13.2784px 0px;
}
`;

export const cardContainerUpcoming = css`
  ${cardContainer};
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
`;

export const cardIcon = css`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  opacity: 0.8;

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 16px;
    border-radius: 8px;
  }
`;

export const cardIconCompleted = css`
  ${cardIcon};
  border: 1px solid #5e57c0;
  color: #5e57c0;
`;

export const cardIconActive = css`
  ${cardIcon};
  border: 1px solid #ee8865;
  color: #ee8865;
`;

export const cardIconUpcoming = css`
  ${cardIcon};
  border: 1px solid #d9d9d9;
  color: #bfbfbf;

  img {
    opacity: 0.5;
  }
`;

export const cardContent = css`
  flex: 1;
  display: flex;
  align-items: center;
  text-align: left;
`;

export const cardTitle = css`
  font-weight: 300;
  font-size: 20px;
  line-height: 1.3;
  margin: 0;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.3;
  }
`;

export const cardTitleCompleted = css`
  ${cardTitle};
  color: #262626;
`;

export const cardTitleActive = css`
  ${cardTitle};
  color: #262626;
`;

export const cardTitleUpcoming = css`
  ${cardTitle};
  color: #8c8c8c;
`;

export const ribbonWrapper = css`
  width: 100%;
  flex: 1;

  .ant-ribbon-wrapper {
    width: 100%;
    flex: 1;
  }
`;
